import { addClass } from '@opten/dom/add-class';
import { removeClass } from '@opten/dom/remove-class';
import { toggleClass } from '@opten/dom/toggle-class';

import { setCookie } from '@opten/cookie/set';
import { removeCookie } from '@opten/cookie/remove';
import { hasAnyParentsWithClass } from '@opten/dom/has-any-parents-with-class';
import { getParentWithClass } from '@opten/dom/get-parent-with-class';

import { hasClass } from '@opten/dom/has-class';
import { Component } from '@opten/compiler/metadata/component';
import { NavbarMegaDropdownFavoriteAdded } from '../navbar/navbar-mega-dropdown-favorite-added';
import { ComponentRefs } from '@opten/compiler/metadata/di';

export class FavoriteElement {
	favorite: HTMLElement;
	domain: string;
	domainName: string;
	location: {
		id: string;
		name: string;
		url: string;
	}
	addButton: HTMLElement;
	removeButton: HTMLElement;
	isFavorite: boolean;
	cookieKey: string;
	navbarMegadropdownToggler?: HTMLElement;
}

export class FavoriteShortCutElement {
	favorite: HTMLElement;
	favoritesChooser: HTMLElement;
	title: HTMLElement;
	domain: string;
}

export class FavoriteLink {
	favorite: HTMLElement;
	domain: string;
	location: {
		id: string;
	};
	isFavorite: boolean;
}

export class FavoriteOptions {
	favoriteClass?: string;
	favoriteShortCutClass?: string;
	favoriteShortCutTitleClass?: string;
	favoriteShortCutChooserClass?: string;
	favoriteLinkClass?: string;
	addFavoriteClass?: string;
	removeFavoriteClass?: string;
	stateClasses?: {
		hide: string;
		active: string;
	}
	attributes?: {
		domain: string;
		domainName: string;
		location: string;
		locationName: string;
		locationUrl: string;
	}
	cookie?: {
		expirationInDays?: number;
		domain?: string;
		path?: string;
		secure?: boolean;
	};
}

@Component({ className: 'js-favorites-domain' })
export class DomainFavoriteComponent {
	@ComponentRefs(NavbarMegaDropdownFavoriteAdded) _navbarMegaDropdownsFavoriteAdded: Array<NavbarMegaDropdownFavoriteAdded>;

	wrapperElement: HTMLElement;
	private favorites: FavoriteElement[] = [];
	favoriteLinks: FavoriteLink[] = [];
	private favoriteShortCuts: FavoriteShortCutElement[] = [];
	domainCookiePrefix = 'OPTEN.Cookie.DomainPage.';
	private isFirstFavoriteClick = true;
	currentDomainContext: string;
	private options: FavoriteOptions = {
		favoriteClass: 'js-favorite',
		favoriteShortCutClass: 'js-favorite-shortcut',
		favoriteShortCutTitleClass: 'js-favorite-shortcut-title',
		favoriteShortCutChooserClass: 'js-favorite-shortcut-chooser',
		favoriteLinkClass: 'js-favorite-link',
		addFavoriteClass: 'js-favorite-add',
		removeFavoriteClass: 'js-favorite-remove',
		stateClasses: {
			hide: 'd-none',
			active: 'is-active'
		},
		attributes: {
			domain: 'data-domain',
			domainName: 'data-domain-name',
			location: 'data-location',
			locationName: 'data-location-name',
			locationUrl: 'data-location-url'
		},
		cookie: {
			expirationInDays: 356,
			secure: false
		}
	}


	constructor(private wrapper: HTMLElement) {
		this.wrapperElement = wrapper;
		this.currentDomainContext = this.wrapperElement.getAttribute(this.options.attributes.domain);
		this.options.cookie.secure = window.location.protocol == 'https:';
		this.init();
	}

	private init() {
		this.initFavoriteElements();
		this.initFavoriteLinks();
		this.initFavoriteShortCuts();
	}

	private initFavoriteElements() {
		const favoriteElements = Array.from(this.wrapperElement.getElementsByClassName(this.options.favoriteClass)) as HTMLElement[];

		if (favoriteElements && favoriteElements.length > 0) {
			favoriteElements.forEach(favorite => {
				const domain = favorite.getAttribute(this.options.attributes.domain);
				const domainName = favorite.getAttribute(this.options.attributes.domainName);

				const location = favorite.getAttribute(this.options.attributes.location);
				const locationName = favorite.getAttribute(this.options.attributes.locationName);
				const locationUrl = favorite.getAttribute(this.options.attributes.locationUrl);

				const addButton = favorite.getElementsByClassName(this.options.addFavoriteClass)[0] as HTMLElement;
				const removeButton = favorite.getElementsByClassName(this.options.removeFavoriteClass)[0] as HTMLElement;


				const favoriteElement: FavoriteElement = {
					favorite: favorite,
					domain: domain,
					domainName: domainName,
					location: {
						id: location,
						name: locationName,
						url: locationUrl
					},
					addButton: addButton,
					removeButton: removeButton,
					isFavorite: false,
					cookieKey: this.domainCookiePrefix + domain
				}
				if (addButton) {
					addButton.addEventListener('click', (e) => this.handleAddDomainFavorite(favoriteElement, e));
					if (hasClass(addButton, this.options.stateClasses.hide)) {
						favoriteElement.isFavorite = true;
					}
				}
				if (removeButton) {
					removeButton.addEventListener('click', (e) => this.handleRemoveDomainFavorite(favoriteElement, e));
				}
				if (hasAnyParentsWithClass(favorite, ['js-navbar-mega-dropdown'])) {
					const navbarMegadropdown = getParentWithClass(favorite, 'js-navbar-mega-dropdown');
					if (navbarMegadropdown) {
						const navbarMegadropdownToggler = navbarMegadropdown.getElementsByClassName('js-mega-dropdown-toggler-full');
						if (navbarMegadropdownToggler && navbarMegadropdownToggler.length > 0) {
							favoriteElement.navbarMegadropdownToggler = navbarMegadropdownToggler[0] as HTMLElement;
						}
					}
				}
				this.favorites.push(favoriteElement);
			});


		}
	}

	private initFavoriteLinks() {
		const favoriteLinkElements = Array.from(this.wrapperElement.getElementsByClassName(this.options.favoriteLinkClass)) as HTMLElement[];
		if (favoriteLinkElements && favoriteLinkElements.length > 0) {
			favoriteLinkElements.forEach(favoriteLinkElement => {
				const domain = favoriteLinkElement.getAttribute(this.options.attributes.domain);
				const location = favoriteLinkElement.getAttribute(this.options.attributes.location);

				const favoriteLink: FavoriteLink = {
					favorite: favoriteLinkElement,
					domain: domain,
					location: {
						id: location,
					},
					isFavorite: false
				}
				this.favoriteLinks.push(favoriteLink);
			});
		}
	}

	private initFavoriteShortCuts() {
		const favoriteShortCutElements = Array.from(this.wrapperElement.getElementsByClassName(this.options.favoriteShortCutClass)) as HTMLElement[];
		if (favoriteShortCutElements && favoriteShortCutElements.length > 0) {
			favoriteShortCutElements.forEach(favorite => {
				const domain = favorite.getAttribute(this.options.attributes.domain);
				const titleElement = favorite.getElementsByClassName(this.options.favoriteShortCutTitleClass)[0] as HTMLElement;
				const favoritesChooser = favorite.parentElement.getElementsByClassName(this.options.favoriteShortCutChooserClass)[0] as HTMLElement;

				const favoriteShortCutElement: FavoriteShortCutElement = {
					favorite: favorite,
					favoritesChooser: favoritesChooser,
					domain: domain,
					title: titleElement
				}
				this.favoriteShortCuts.push(favoriteShortCutElement);
			});
		}

	}

	handleRemoveDomainFavorite(favoriteElement: FavoriteElement, event: Event = null): any {
		if (event != null) {
			event.stopPropagation();
			event.preventDefault();
		}
		if (this._navbarMegaDropdownsFavoriteAdded && this._navbarMegaDropdownsFavoriteAdded.length > 0) {
			this._navbarMegaDropdownsFavoriteAdded.forEach(o => o.hide());
		}
		this._removeCookie(favoriteElement);
		this.removeFavoriteAsFavorite(favoriteElement);
		this.handleRemoveDomainFavoriteShortCut(favoriteElement);
		this.removeDomainFavorites(favoriteElement);

	}
	handleAddDomainFavorite(favoriteElement: FavoriteElement, event: Event = null): any {
		if (event != null) {
			event.stopPropagation();
			event.preventDefault();
		}
		this.removeDomainFavorites(favoriteElement);
		this._setCookie(favoriteElement);
		this.addDomainFavorite(favoriteElement);
		this.addFavoriteToFavoriteLinks(favoriteElement);
		if (this.isFirstFavoriteClick) {
			this.isFirstFavoriteClick = false;
			this.favorites
				.forEach(favorite => removeClass(favorite.addButton, 'c-favorite-link--click-me'));
		}
		this.handleAddDomainFavoriteShortCut(favoriteElement);
		if (favoriteElement.navbarMegadropdownToggler) {
			favoriteElement.navbarMegadropdownToggler.dispatchEvent(new Event('click'));
		}
		if (this._navbarMegaDropdownsFavoriteAdded && this._navbarMegaDropdownsFavoriteAdded.length > 0) {
			this._navbarMegaDropdownsFavoriteAdded.forEach(o => o.show(favoriteElement.location.name, favoriteElement.domainName));
		}
	}

	private addDomainFavorite(favoriteElement: FavoriteElement) {
		this.favorites
			.filter(o => o.domain == favoriteElement.domain && o.location.id === favoriteElement.location.id)
			.forEach(favorite => this.addFavoriteAsFavorite(favorite));
	}

	private removeDomainFavorites(favoriteElement: FavoriteElement) {
		this.favorites
			.filter(o => o.domain == favoriteElement.domain)
			.forEach(favorite => this.removeFavoriteAsFavorite(favorite));
	}

	private handleRemoveDomainFavoriteShortCut(favoriteElement: FavoriteElement) {
		if (this.favoriteShortCuts.length > 0) {
			this.favoriteShortCuts.forEach(favoriteShortCut => {
				if (favoriteShortCut.domain == favoriteElement.domain) {
					addClass(favoriteShortCut.favorite, this.options.stateClasses.hide);
					if (favoriteShortCut.favoritesChooser) {
						removeClass(favoriteShortCut.favoritesChooser, this.options.stateClasses.hide);
					}
				}
			});
		}
	}
	private handleAddDomainFavoriteShortCut(favoriteElement: FavoriteElement) {
		if (this.favoriteShortCuts.length > 0) {
			this.favoriteShortCuts.forEach(favoriteShortCut => {
				if (favoriteShortCut.domain == favoriteElement.domain) {
					favoriteShortCut.title.innerHTML = favoriteElement.location.name;
					favoriteShortCut.favorite.setAttribute("href", favoriteElement.location.url);
					favoriteShortCut.favorite.setAttribute("title", favoriteElement.location.name);
					removeClass(favoriteShortCut.favorite, this.options.stateClasses.hide);
					if (favoriteShortCut.favoritesChooser) {
						addClass(favoriteShortCut.favoritesChooser, this.options.stateClasses.hide);
					}
				}

			});
		}
	}


	private addFavoriteAsFavorite(favoriteElement: FavoriteElement) {
		favoriteElement.isFavorite = true;
		addClass(favoriteElement.addButton, this.options.stateClasses.hide);
		removeClass(favoriteElement.removeButton, this.options.stateClasses.hide);
	}

	private addFavoriteToFavoriteLinks(favoriteElement: FavoriteElement) {
		if (this.favoriteLinks.length > 0) {
			this.favoriteLinks
				.filter(o => o.domain == favoriteElement.domain)
				.forEach(favoriteLink => this.setFavoriteLink(favoriteLink, favoriteElement.location.id));
		}
	}

	private setFavoriteLink(favoriteLink: FavoriteLink, locationId: string) {
		toggleClass(favoriteLink.favorite, this.options.stateClasses.active, favoriteLink.location.id == locationId)
	}

	removeFavoriteAsFavorite(favoriteElement: FavoriteElement) {
		removeClass(favoriteElement.addButton, this.options.stateClasses.hide);
		addClass(favoriteElement.removeButton, this.options.stateClasses.hide);
		favoriteElement.isFavorite = false;

		if (this.favoriteLinks.length > 0) {
			this.favoriteLinks
				.filter(o => o.domain == favoriteElement.domain && o.location.id == favoriteElement.location.id)
				.forEach(favoriteLink => removeClass(favoriteLink.favorite, this.options.stateClasses.active));
		}
	}

	private _setCookie(favoriteElement: FavoriteElement): void {
		if (!favoriteElement.cookieKey) {
			throw new Error(
				`Cookie-Consent: Cannot set Cookie, no key defined!`
			);
		}

		const date = new Date();
		date.setDate(
			date.getDate() + 365
		);

		setCookie(
			favoriteElement.cookieKey,
			favoriteElement.location.id + "_true",
			date,
			this.options.cookie.path,
			this.options.cookie.domain,
			this.options.cookie.secure
		);
	}

	private _removeCookie(favoriteElement: FavoriteElement): void {
		if (!favoriteElement.cookieKey) {
			throw new Error(
				`Cookie-Consent: Cannot remove Cookie, no key defined!`
			);
		}
		const date = new Date();
		date.setDate(
			date.getDate() + 365
		);
		setCookie(
			favoriteElement.cookieKey,
			favoriteElement.location.id + "_false",
			date,
			this.options.cookie.path,
			this.options.cookie.domain,
			this.options.cookie.secure
		);
		removeCookie(
			favoriteElement.cookieKey,
			this.options.cookie.path,
			this.options.cookie.domain
		)
	}
}
